import type { MaybeRefOrGetter, Ref } from 'vue'

import { ref, toValue } from 'vue'

export default function useDiscardGuard(
  isDirty: MaybeRefOrGetter<boolean>,
  close: () => void
): {
  confirmingDiscard: Ref<boolean>
  requestClose: () => void
  discard: () => void
} {
  const confirmingDiscard = ref(false)

  const requestClose = (): void => {
    if (toValue(isDirty)) {
      confirmingDiscard.value = true
    } else {
      close()
    }
  }

  const discard = (): void => {
    confirmingDiscard.value = false
    close()
  }

  return { confirmingDiscard, requestClose, discard }
}
